import get from 'lodash/get';
import * as mic2020YearPageActions from '../../action_creators/mic/mic2020_year_page_action_creators';
import log from '../../../services/logger_service';

import mic2020CompaniesActions from './async_mic2020_company_actions';
import mic2020RegionsActions from './async_mic2020_regions_actions';
import mic2020SectorsActions from './async_mic2020_sectors_actions';

import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';

export default function fetchMic2020Page(params, store) {
  return function firstDispatch(dispatch) {
    dispatch(mic2020YearPageActions.mic2020YearPageLoading({}, store));
    return Promise.all([
      mic2020CompaniesActions(params, store)(dispatch),
      mic2020SectorsActions(params, store)(dispatch),
      mic2020RegionsActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(mic2020YearPageActions.mic2020YearPageLoaded({}, store));
        return true;
      })
      .catch(function handleUserError(err) {
        const status = get(err, 'response.status') || 500;

        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(err, `Error in tag page actions, message: ${err.message}`);
        }
        dispatch(mic2020YearPageActions.mic2020YearPageLoadError(err, store));
      });
  };
}
